/* ── live sync: Shopify is the source of truth for price, sale price and stock.
      Patches window.CATALOG from /products.json before the shop renders, then
      loads the page scripts in order. If the fetch fails we still boot, using
      the prices baked into eco-catalog.js. ── */
(function () {
  // eco-pdp needs window.ECO_CART, so it must come after eco-cart
  var SCRIPTS = ['eco-shop.js', 'eco-cart.js', 'eco-pdp.js', 'eco-page.js',
                 'eco-chat.js', 'eco-popup-guard.js'];
  var base = (document.currentScript && document.currentScript.src || '').replace(/eco-boot\.js.*$/, '');

  /* On phones the full-size scrub videos are ~24MB of cellular data. Swap in the
     720px encodes instead — same duration, so the scroll scrubbing stays in sync,
     and the section still plays exactly as designed. */
  function useMobileVideos() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w <= 0 || w > 760) return;      // w of 0 means the viewport isn't measurable yet
    ['heroVideo', 'soilVideo'].forEach(function (id) {
      var v = document.getElementById(id);
      var s = v && v.querySelector('source');
      if (!s) return;
      /* the mobile URL comes from Liquid so it carries its own ?v= cache key —
         building it by string surgery dropped the key and served a stale file */
      var mobile = s.getAttribute('data-mobile-src');
      if (!mobile || s.getAttribute('src') === mobile) return;
      s.setAttribute('src', mobile);
      try { v.load(); } catch (e) {}
    });
  }

  /* Sale display is switched off store-wide: show one plain price, no struck-through
     "was" and no Save% badge. This only changes what the site shows — the compare-at
     prices still live in Shopify, and customers are still charged the current price.
     Set SHOW_SALE_PRICES back to true to bring the badges back. */
  var SHOW_SALE_PRICES = false;
  function applySaleDisplay() {
    if (SHOW_SALE_PRICES) return;
    (window.CATALOG || []).forEach(function (p) { p.was = null; });
  }

  /* A card advertises a pack ("25pc (10\")"), so it must never price or sell a
     single-plate sample. eco-catalog.js pinned this handle to the $5 sample variant,
     which made the card read $5 and put one 6" plate in the cart. Pin it to the
     matching 25-pack instead. */
  var VID_OVERRIDES = {
    'bamboo-plate-palm-leaf-25-pice-square-10-disposable-compostable': '49604165468450'
  };
  /* Same trap, generally: if a stored vid still resolves to a sample variant,
     fall back to the product's first real variant rather than advertising it. */
  var SAMPLE_RE = /\b(1\s*piece\s*sample|sample)\b/i;

  function boot() {
    applySaleDisplay();
    useMobileVideos();
    SCRIPTS.forEach(function (name) {
      var s = document.createElement('script');
      s.src = base + name + (window.ECO_V ? '?v=' + window.ECO_V : '');
      s.async = false;            // preserve execution order
      document.body.appendChild(s);
    });
  }

  function patch(products) {
    var byHandle = {};
    products.forEach(function (p) { byHandle[p.handle] = p; });
    var synced = 0, changed = 0, corrected = 0, dropped = 0;

    /* A handle missing from /products.json is archived, unpublished or deleted in
       Shopify. Showing it as a permanently "Sold out" card is worse than not showing
       it — one such entry duplicated a product that is actually in stock. Drop them,
       and keep the catalogue array itself as the single list the shop renders from.
       If the fetch fails, patch() never runs and the full baked-in catalogue stands. */
    var kept = (window.CATALOG || []).filter(function (item) {
      if (byHandle[item.handle]) return true;
      dropped++;
      return false;
    });

    kept.forEach(function (item) {
      var sp = byHandle[item.handle];

      var wanted = VID_OVERRIDES[item.handle] || item.vid;
      var v = null;
      for (var i = 0; i < sp.variants.length; i++) {
        if (String(sp.variants[i].id) === String(wanted)) { v = sp.variants[i]; break; }
      }
      if (v && SAMPLE_RE.test(v.title || '') && sp.variants.length > 1) { v = null; corrected++; }
      if (!v) {
        // first variant that isn't a sample; Shopify's variant order is the merchandiser's
        for (var j = 0; j < sp.variants.length; j++) {
          if (!SAMPLE_RE.test(sp.variants[j].title || '')) { v = sp.variants[j]; break; }
        }
      }
      if (!v) v = sp.variants[0];

      var price = parseFloat(v.price);
      var was = v.compare_at_price ? parseFloat(v.compare_at_price) : null;
      if (price !== item.price || (was || 0) !== (item.was || 0)) changed++;

      item.price = price;
      item.was = (was && was > price) ? was : null;   // only a real discount counts
      item.avail = v.available !== false;
      item.vid = String(v.id);
      item.buy = '/cart/' + v.id + ':1';
      synced++;
    });

    window.CATALOG = kept;
    window.ECO_SYNC = { synced: synced, changed: changed, corrected: corrected, dropped: dropped, total: kept.length };
  }

  var done = false;
  var go = function () { if (!done) { done = true; boot(); } };
  setTimeout(go, 5000);   // never let a slow request block the page

  var jobs = [
    fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.products) patch(d.products); })
  ];

  /* collection pages: gather every handle in the collection, past Liquid's 50 cap */
  if (window.ECO_COLLECTION) {
    jobs.push(
      fetch('/collections/' + window.ECO_COLLECTION + '/products.json?limit=250',
            { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.products) {
            window.ECO_SUBSET = d.products.map(function (p) { return p.handle; });
          }
        })
    );
  }

  try {
    Promise.all(jobs.map(function (j) { return j.catch(function () {}); })).then(go, go);
  } catch (e) { go(); }
})();
